/* ポイント処理 - 付与予定ポイント試算API (POST) */
class PointUtil {
  #domain = window.location.href.includes('gocart-stg') ? "9ulkjbiiz0.execute-api.ap-northeast-1.amazonaws.com/dev" : "t2o4cfsskd.execute-api.ap-northeast-1.amazonaws.com/prod";
  #path = "";

  /**
   * リクエスト情報の組み立て
   * @param {Array<{id: string, amount: number}>} variants
   * @returns {Object}
   */
  buildRequestBody(variants) {
    return {
      variants: Array.isArray(variants) ? variants : [],
    };
  }

  /**
   * 付与予定ポイント試算APIを呼び出す（POST）
   * @param {Object} [body]
   * @returns {Promise<Object|null>}
   */
  async request(body, path) {
    this.#path = path;
    const url = `https://${this.#domain}/${this.#path}`;

    try {
      console.log(`[point-util] body:`, body);
      const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body || {}),
      });

      if (!response.ok) throw new Error(response.status);
      return await response.json();
    } catch (error) {
      console.error(`[point-util] error:`, error);
      return null;
    }
  }

  /**
   * API失敗時のエラーメッセージ表示
   * @param {Element} insertAfterEl - メッセージ挿入箇所の要素
   * @param {Object} [options] - オプション
   * @param {boolean} [options.alignRight] - true で右寄せ
   * @param {boolean} [options.isProduct] - 商品詳細の場合は true
   */
  showPointErrorMessage(insertAfterEl, options = {}) {
    if (!insertAfterEl) return;
    const p = document.createElement("p");
    p.className = "customer-point-message";
    if (options.alignRight) p.classList.add("customer-point-message--right");
    if (options.isProduct) p.classList.add("customer-point-message--product");
    p.innerHTML = "ポイント情報を取得できませんでした。<br>しばらく時間をおいてから再度お試しください。";
    if (options.isProduct) insertAfterEl.style.marginBottom = "0";
    insertAfterEl.after(p);
  }

  /**
   * エラーメッセージを挿入する箇所の要素を算出
   * @param {Element} countEl - ポイント表示箇所の要素
   * @returns {Object} - エラーメッセージを挿入する箇所の要素と、商品詳細の場合は true
   */
  getInsertTarget(countEl) {
    const productPointBlock = countEl.closest("p.p-item-info__point.u-mb--2");
    let insertAfterEl = productPointBlock || countEl.closest("p.p-item-info__point") || countEl.parentElement;
    const dl = countEl.closest("dl");
    if (dl && insertAfterEl?.parentElement === dl) insertAfterEl = dl;
    return { insertAfterEl, isProduct: !!productPointBlock };
  }

  /**
   * API失敗時にエラー表示を行い、null を返す
   */
  showErrorAndReturnNull(countEl, options) {
    const { insertAfterEl, isProduct } = this.getInsertTarget(countEl);
    this.showPointErrorMessage(insertAfterEl, {
      alignRight: options.alignRight,
      isProduct,
    });
    return null;
  }

  /**
   * 獲得予定ポイントの表示
   * @param {Array<{id: string, amount: number}>} variants
   * @param {string} selector - ポイント表示箇所のセレクタ
   * @param {Object} [options] - オプション
   * @param {boolean} [options.alignRight] - true で右寄せ
   * @returns {Promise<Object|null>}
   */
  async displayWillGetPoints(variants, selector, options = {}) {
    const countEl = document.querySelector(selector);
    if (!countEl) return;

    const productPointBlock = countEl.closest("p.p-item-info__point.u-mb--2");
    const body = this.buildRequestBody(variants);

    try {
      const response = await this.request(body, "will-get-points");
      console.log(`[point-util] response:`, response);

      if (!response) return this.showErrorAndReturnNull(countEl, options);

      const campaignPoint = response.campaignPoint ?? 0;
      const normalPoint = response.normalPoint ?? 0;
      const totalPoint = campaignPoint + normalPoint;

      const formatDate = (dateTimeData) => {
        if (!dateTimeData || dateTimeData.length < 16) return "";
        const y = dateTimeData.slice(0, 4);
        const m = dateTimeData.slice(5, 7);
        const d = dateTimeData.slice(8, 10);
        const hr = dateTimeData.slice(11, 13);
        const min = dateTimeData.slice(14, 16);
        return `${y}年${m}月${d}日 ${hr}時${min}分`;
      };
      
      const campaignName = response.variants?.[0]?.campaign.name ??'';
      const campaignStartDateTime = formatDate(response.variants?.[0]?.campaign?.startDatetime);
      const campaignEndDateTime = formatDate(response.variants?.[0]?.campaign?.endDatetime);

      const campaignPeriod = (campaignStartDateTime && campaignEndDateTime) ? `${campaignStartDateTime} 〜 ${campaignEndDateTime}` : "";

      if (productPointBlock) {
        this.showProductPointBlock(productPointBlock, countEl, campaignPoint, normalPoint, totalPoint);
        this.showCampaignDetails(productPointBlock, campaignPoint, campaignName, campaignPeriod);
      } else {
        countEl.textContent = totalPoint;
      }
    } catch (error) {
      console.error(`[point-util] error:`, error);
      return this.showErrorAndReturnNull(countEl, options);
    }
  }

  /**
   * 商品詳細画面のポイントブロックの表示
   * @param {Element} productPointBlock 
   * @param {Element} countEl 
   * @param {number} campaignPoint 
   * @param {number} normalPoint 
   * @param {number} totalPoint 
   */
  showProductPointBlock(productPointBlock, countEl, campaignPoint, normalPoint, totalPoint) {
    // 通常ポイント
    countEl.textContent = normalPoint;
    // 期間限定ポイント対象
    const mainParent = productPointBlock.closest('div').parentElement.parentElement;
    const campaignWrapDiv = mainParent?.querySelector(".campaign_point_wrapper");

    // 期間限定ポイントが存在する場合、期間限定ポイント要素を表示
    if (campaignPoint > 0) {
      productPointBlock.style.textDecoration = 'line-through';
      productPointBlock.style.marginBottom = '0px';

      if (campaignWrapDiv) {
       mainParent.querySelectorAll('.has-campaign-name-row .count').forEach(el => el.textContent = totalPoint);
      }
    } else {
      productPointBlock.style.textDecoration = 'none';
      productPointBlock.style.marginBottom = '';
    }
  }

 /**
   * キャンペーン情報の詳細（キャンペーン名・期間）を表示
   * @param {Element} productPointBlock - ポイント表示親要素
   * @param {number} campaignPoint - キャンペーンポイント数（0より大きい場合に表示）
   * @param {string} campaignName - キャンペーン名
   * @param {string} campaignPeriod - 「〇〇〇〇年〇〇月〇〇日〇〇時〇〇分」にフォーマット適用済みのキャンペーン期間文字列
   */
  showCampaignDetails(
    productPointBlock,
    campaignPoint,
    campaignName,
    campaignPeriod,
  ) {
    const mainParent =
      productPointBlock.closest("div").parentElement.parentElement;

    //キャンペーンポイント表示用要素を取得
    const campaignPointWrapper = mainParent.querySelector(
      ".campaign_point_wrapper",
    );
    const campaignInfoWrapper = mainParent.querySelector(
      ".campaign_info_wrapper",
    );

    if (campaignPoint > 0) {
      const endDateTimeEl = mainParent.querySelector(".campaign-period");
      const campaignNameEl = mainParent.querySelector(".campaign-name");

      if (endDateTimeEl) endDateTimeEl.textContent = campaignPeriod;
      if (campaignNameEl) campaignNameEl.textContent = campaignName;

      if (campaignPointWrapper) campaignPointWrapper.style.display = "flex";
      if (campaignInfoWrapper) campaignInfoWrapper.style.display = "block";
    } else {
      if (campaignPointWrapper) campaignPointWrapper.style.display = "none";
      if (campaignInfoWrapper) campaignInfoWrapper.style.display = "none";
    }
  }
}
